import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import POSConfigModule from "@/store/modules/pos-config";
import { computed, defineComponent, watchEffect } from "vue";
export default defineComponent({
  name: "GridsListing",
  setup: function setup() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var grids, selectedGrid, firstGrid, selectedConfig, selectGrid;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              selectGrid = function _selectGrid(grid) {
                POSConfigModule.selectGrid(grid);
              };

              grids = computed(function () {
                return POSConfigModule.sortedGrids;
              });
              selectedGrid = computed(function () {
                return POSConfigModule.selectedGrid;
              });
              firstGrid = computed(function () {
                return POSConfigModule.firstGrid;
              });
              selectedConfig = computed(function () {
                return POSConfigModule.getSelectedConfig;
              }); // // Get timeslots from remote and store them locally
              // // a. get product categories from local db
              // let productCategories: IProductCategory[] | undefined =
              //   await getAllProductCategories();
              // // b. fetch all corresponding timeSlots from remote db and store them locally
              // let productCategoriesIds = productCategories?.map((pc) => pc.id) || [];
              // alert('going to get timeslots from remote');
              // await fetchAllPCsTimeslots(productCategoriesIds);
              // alert('Ok, I got timeslots');

              return _context.abrupt("return", {
                grids: grids,
                selectedGrid: selectedGrid,
                selectGrid: selectGrid,
                firstGrid: firstGrid,
                selectedConfig: selectedConfig
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this = this;

    // If there is a selected Config watch it
    // When user switches configs we are supposed to show him empty lists until he selects a given ticketGroup
    watchEffect( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this.selectedConfig.value) {
                _this.selectGrid(null);
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
  }
});